import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useTranslation } from 'components/lib';

export default function CartesianProduct({ setData, selectedOperation, relations, ...props }) {

    const tableContainer = {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        width: '90%',
        gap: '16px'
    }

    relations = relations.map(entry => entry.elements);
    const { t } = useTranslation()

    return (
        <>
            {
                (selectedOperation === 'cartesian' || selectedOperation === 'relation') && setData[0]?.length <= 5 && setData[1]?.length <= 5 ?
                    (
                        <div id='tableContainer' style={tableContainer}>
                            <TableContainer component={Paper}>
                                <Table size='small' aria-label="cartesian-product-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell key={'zerozero'}>×</TableCell>
                                            {setData[1].map((set, index) => (
                                                <TableCell key={`header-${set}${index}`}>{set}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {setData[0].map((setAElement, columnIndex) => (
                                            <TableRow key={`${setAElement}${columnIndex}`}>
                                                <TableCell key={`${setAElement}-A-column`}>
                                                    {setAElement}
                                                </TableCell>
                                                {setData[1].map((setBElement, rowIndex) => (
                                                    <TableCell
                                                        key={`cp-${setAElement}${setBElement}`}
                                                        sx={{
                                                            backgroundColor: relations.includes(setAElement + '|' + setBElement)
                                                                ? 'mediumseagreen'
                                                                : '#d1c9c940',
                                                            color: relations.includes(setAElement + '|' + setBElement) ? 'white' : 'black'
                                                        }}
                                                    >
                                                        ({setAElement}, {setBElement})
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    )
                    :
                    (
                        <div id='cartesianMessageContainer' style={{ fontWeight: 700 }}>
                            {
                                (setData[0]?.length <= 5 && setData[1]?.length <= 5)
                                    ? t('Labs.Nodes.NodeSets.cartesian.operation')
                                    : t('Labs.Nodes.NodeSets.cartesian.set')
                            }
                        </div>
                    )
            }
        </>
    );
}